import { memo } from 'react';
import { Handle } from 'reactflow';
import "./styles.css";

const GreyCircleNode = memo(({ data }) => {
  return (
    <div className="int__grey-circle-node"
      style={{
        backgroundColor: "#4f4f4f",
        padding: "14px",
        borderRadius: "50px"
      }}
    >
      <Handle
        type="target"
        position="top"
        id="input"
        style={{ width: 0, height: 0, top: 1, border: "none", backgroundColor: "transparent" }}
      />

      <div
        style={{
          marginTop: "-12px",
          marginLeft: "-90px"
        }}>
        <input className="nodrag" type="text" defaultValue={data.label} onChange={event => data.label = event.target.value} style={{ textAlign: "center", width: 170, fontSize: 13 }} />
      </div>
      <Handle
        type="target"
        position="left"
        id="input_left"
        style={{ width: 0, height: 0, backgroundColor: "transparent", top: 15, left: -72 }}
      />
      <Handle
        type="source"
        position="right"
        id="output_right"
        style={{ width: 0, height: 0, backgroundColor: "transparent", top: 15, left: -62 }}
      />
      <Handle
        type="source"
        position="bottom"
        id="output"
        style={{ width: 20, height: 0, bottom: 20, border: "none", backgroundColor: "transparent" }}
      />
    </div>
  );
});

GreyCircleNode.displayName = 'GreyCircleNode';
export default GreyCircleNode;